export default class Configuration {
  static get EnvConfig() {
    return {
      VUE_APP_KEYCLOAK_URL: "$VUE_APP_KEYCLOAK_URL",
      VUE_APP_REALM: "$VUE_APP_REALM",
      VUE_APP_CLIENT_ID: "$VUE_APP_CLIENT_ID",
      VUE_APP_WEBAPI: "$VUE_APP_WEBAPI",
      VUE_APP_WIJMO_LICENCE: "$VUE_APP_WIJMO_LICENCE",
    };
  }
  static value(key) {
    const value = this.EnvConfig[key];

    if (!value) {
      console.error(`Configuration: Value for "${key}" is not defined`);
      return;
    }

    return value;
  }
}
